import { createSlotRecipe } from './runtime.mjs';

const toastConfig = {"name":"toast","className":"ds-toast","slots":["root","icon","content","heading","body","actions","dismiss"],"defaultVariants":{"dismissable":false,"size":"default"},"variantMap":{"size":["default","compact"],"dismissable":["true","false"]}}

export const toast = /* @__PURE__ */ createSlotRecipe(toastConfig)